import { render, staticRenderFns } from "./ControlLibrarySetting.vue?vue&type=template&id=126c089b&scoped=true&"
import script from "./ControlLibrarySetting.vue?vue&type=script&lang=js&"
export * from "./ControlLibrarySetting.vue?vue&type=script&lang=js&"
import style0 from "./ControlLibrarySetting.vue?vue&type=style&index=0&id=126c089b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c089b",
  null
  
)

export default component.exports